document.documentElement.classList.add('js');

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      // Limpa estilos de fechamento ao abrir
      this.content.style.opacity = '';
      this.content.style.transform = '';
      this.content.style.pointerEvents = '';
      this.content.classList.remove('is-closing');
    }
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    this.content.classList.add('is-closing');
    this.content.style.opacity = '0';
    this.content.style.transform = 'translateY(-1.5rem)';
    this.content.style.pointerEvents = 'none';

    const onTransitionEnd = (event) => {
      if (event.propertyName === 'opacity') {
        this.content.classList.remove('is-closing');
        this.content.removeEventListener('transitionend', onTransitionEnd);
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        this.content.style.opacity = '';
        this.content.style.transform = '';
        this.content.style.pointerEvents = '';
      }
    };
    this.content.addEventListener('transitionend', onTransitionEnd);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.isDesktop = window.innerWidth >= 1024;
    this.closeTimeout = null;
    this.enableHoverCafes = this.dataset.enableHoverCafes === 'true';
    this.isCafeMenu = this.mainDetailsToggle.querySelector('summary').textContent.trim().includes('Cafés');
    this.addHoverListeners();
    window.addEventListener('resize', this.handleResize);
  }

  addHoverListeners() {
    if (this.isDesktop) {
      // Se o checkbox estiver ativado, só adiciona hover no menu Cafés
      // Se estiver desativado, adiciona em todos
      if (!this.enableHoverCafes || (this.enableHoverCafes && this.isCafeMenu)) {
        this.mainDetailsToggle.addEventListener('mouseenter', this.handleMouseEnter);
        this.mainDetailsToggle.addEventListener('mouseleave', this.handleMouseLeave);
      } else {
        this.mainDetailsToggle.removeEventListener('mouseenter', this.handleMouseEnter);
        this.mainDetailsToggle.removeEventListener('mouseleave', this.handleMouseLeave);
      }
    } else {
      this.mainDetailsToggle.removeEventListener('mouseenter', this.handleMouseEnter);
      this.mainDetailsToggle.removeEventListener('mouseleave', this.handleMouseLeave);
    }
  }

  handleResize() {
    const wasDesktop = this.isDesktop;
    this.isDesktop = window.innerWidth >= 1024;
    if (this.isDesktop !== wasDesktop) {
      this.addHoverListeners();
    }
  }

  handleMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    // Força reflow para garantir a transição
    this.content.offsetHeight;
    this.mainDetailsToggle.setAttribute('open', true);
  }

  handleMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 300);
  }

  onToggle() {
    super.onToggle && super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
